import React, { useRef } from 'react'
import { useFrame, useThree } from 'react-three-fiber'

export default function FollowLight({ mouse }) {
  const light = useRef()
  const { size, viewport } = useThree()
  const aspect = size.width / viewport.width

  useFrame(() => {
    light.current.position.set(mouse.current[0] / aspect, -mouse.current[1] / aspect + 7.5, 5)
  })

  return (
    <pointLight ref={light} distance={40} intensity={4}/>
  )
}
